import { axiosClient } from "../api";
import { URLS } from "../constants";
import { isResponseSuccess } from "../utils";


export const getDashBoard = async (startDate: number, endDate: number) => {
  try {
    const response = await axiosClient.get(URLS.GET_DASHBOARD(startDate, endDate));
    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to get dashboard data')
    }
    return response;
  } catch (e) {
    throw new Error("Failed to get Dashboard Data");
  }
};